export class CustomerComponentMap {
  id: string;
  label: string;
  customerId: string;
  customerLabel: string;
  createdAt: number;
  updatedAt: number;
}
